import "../../../src/assets/css/home.css";
import Banner from "./Banner";
import WhyChooseMeera from "./WhyChoose";
import Certifications from "./Certifications";
import Advantages from "./Advantages";
import Quality from "./Quality";
import ReelSection from "./Feed";
import UpcomingEvents from "./UpcomingEvents";
import TrendyBlog from "./TrendyBlog";

export default function Home() {
    document.title = "Midamas";
    return (
        <>
            <div style={{ overflow: 'hidden', background: "#fff" }}>                
                <Banner />
                <WhyChooseMeera />
                <Certifications />
                <Advantages />
                <Quality />
                <TrendyBlog />
                <UpcomingEvents />
                <ReelSection />
            </div>
        </>
    );
}
